<!-- 所有乡镇报抽统计 -->
<template>
    <div class="main-area">
        <div v-if="$route.meta.rank == 2">
            <el-breadcrumb separator=":">
                <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                <el-breadcrumb-item>抽污情况数据统计</el-breadcrumb-item>
            </el-breadcrumb>

            <el-row class="margin-top-10">
                <el-col :span="2" class="margin-top-10">
                    <label class="search-label">
                    起止时间:
                    </label>
                </el-col>
                <el-col :span="6" class="margin-top-10">
                    <el-date-picker
                    v-model="searchForm.updateTime"
                    :size="GLOBAL.config.systemSize"
                    type="datetimerange"
                    align="right"
                    unlink-panels
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    style="width: 100%;">
                    </el-date-picker>
                </el-col>
                <el-col :span="2" class="margin-top-10">
                    <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" icon="el-icon-search">查询
                    </el-button>
                </el-col>
            </el-row>

            <el-table style="width: 100%"
                :data="tableData"
                element-loading-text="数据处理中...请稍等..."
                @cell-click="changeIndex"
                v-loading="loading">
                <el-table-column prop="name" label="行政区划" align="center">
                    <template slot-scope="scope">
                      {{scope.row.name}}
<!--                        <router-link v-bind:to="'/villagesBCStatistics/townsBCStatistics/'+scope.row.code + '/' + new Date().getTime()">{{scope.row.name}}</router-link>-->
                    </template>
                </el-table-column>

                <el-table-column prop="pumpNum" label="抽污次数" align="center"/>
            </el-table>

        </div>
        <div v-else><router-view></router-view></div>
    </div>
</template>

<script>
export default {
    name: 'VillagesBCStatistics',
    data () {
        return {
            // 查询表单
            searchForm: {
                updateTime: ''
            },
            tableData: [
            ],
            loading: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                }
            }
        }
    },

    methods: {
        changeIndex (data) {
         if(!data.code){
           return
         }
          this.$router.push({
            name: 'TownsBCStatistics',
            params: {
              villageCode: data.code,
              searchForm:this.searchForm
            }
          })
          // if (this.index === '0') {
          //   this.init()
          // } else {
          //   this.biaogeChange(data.code)
          // }
        },
        doSearch () {
            console.log('1111111111111')
            this.getTableData()
        },
        // 分页方法
        tableSizeChange: function (pageSize) {
            this.pagination.pageSize = pageSize
            this.getTableData()
        },
        currentChange: function (current) {
            this.pagination.currentPage = current
            this.getTableData()
        },
        getTableData (initPageFlag) {
            this.loading = true
            let _this = this, searchParams = this.searchForm
            let beginTime = ''
            let endTime = ''
            _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
            var reg = /-| |:/g
            if (_this.searchForm.updateTime) {
                if (_this.searchForm.updateTime[0]) {
                    beginTime = _this.searchForm.updateTime[0].replace(reg, '') + '00'
                }
                if (_this.searchForm.updateTime[1]) {
                    endTime = _this.searchForm.updateTime[1].replace(reg, '') + '00'
                }
            }
            // 3、 调接口获取数据
            let param = {
                // baseService : "TGcBxxxServiceImpl",
                baseService: _this.GLOBAL.config.baseServiceType.TGcBxxxServiceImpl,
                timeTwo: {
                    beginTime: beginTime,
                    endTime: endTime,
                    'type': '2'
                }

            }
            // _this.FUNCTIONS.systemFunction.jsonPost(
            //     _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
            //     param,
            console.log(JSON.stringify(param))
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                // "getVillages",
                _this.GLOBAL.config.handleType.getVillages,
                param,
                null,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        // 结果参数赋值
                        _this.tableData = resultData.obj
                    } else {
                        _this.$message.warning('获取列表数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        }
    },
    mounted () {
        this.getTableData()
    }
}
</script>

<style scoped>
    a {
        text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// src/view/statistics/VillagesBCStatistics.vue